export const TableBlogClassNames = {
  TABLE: 'table-blog-table-element',
  ROW: 'table-blog-row-element',
  CELL: 'table-blog-cell-element',
  CELL_CONTENT_CONTAINER: 'cell-content-container',
};
